import * as OptionalDate from "@silversea-ssc/dotcom-api-types/OptionalDate";
import { dateFromOptionalDate } from "src/utils/date";
import { forceResTimezone } from "src/utils/date/forceResTimezone";

export const isPromoValid = (
  promoCode: string,
  promoExpirationDate: OptionalDate.OptionalDate
): boolean => {
  //TODO: check if can be removed
  if (promoCode !== "a") {
    return false;
  }

  const formattedDate = dateFromOptionalDate(promoExpirationDate);

  if (!formattedDate) {
    return false;
  }
  const today = forceResTimezone(new Date());
  return today <= formattedDate;
};
